import { Button, MenuItem, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getListadoRendicion } from "../../../redux/slices/informes";

export default function ListadoRendicionFilter() {
  const { data: users } = useSelector((state) => state.users);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const submitData = ({ initial_date, final_date, userId }) => {
    dispatch(getListadoRendicion(initial_date, final_date, userId));
  };

  return (
    <form onSubmit={handleSubmit(submitData)} className="flex gap-4">
      <div className="w-full flex">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            id={"initial_date"}
            control={control}
            name={"initial_date"}
            // defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    sx: { mr: "20px" },
                    error: !!errors["initial_date"],
                    // helperText: errors['fecha_ingreso'] && ListOfErrors[errors['fecha_ingreso'].type],
                  },
                }}
                onChange={onChange}
                value={value || null}
              />
            )}
          />
        </LocalizationProvider>
      </div>
      <div className="w-full flex">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            id={"final_date"}
            control={control}
            name={"final_date"}
            // defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    sx: { mr: "20px" },
                    error: !!errors["final_date"],
                    // helperText: errors['fecha_ingreso'] && ListOfErrors[errors['fecha_ingreso'].type],
                  },
                }}
                onChange={onChange}
                value={value || null}
              />
            )}
          />
        </LocalizationProvider>
      </div>
      <Controller
        id="userId"
        name="userId"
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            fullWidth
            select
            size="small"
            onChange={onChange}
            value={value || ""}
            label="Usuario"
            error={errors["userId"]}
            placeholder=""
            sx={{
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
              },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              },
            }}
          >
            {users?.map(
              (option) =>
                option.id && (
                  <MenuItem key={option.id} dense divider value={option.id}>
                    {option.nombre}
                  </MenuItem>
                )
            )}
          </TextField>
        )}
      />
      <Button variant="outlined" type="submit">
        Filtrar
      </Button>
    </form>
  );
}
